import { useEffect } from 'react';
// Singleton variable that we use to globally track whether
// a given editor was the last active ('focused') editor (to narrow
// down editor that should be reacting to Rovo pub-sub messages)
var lastActiveEditorView = null;
export var updateLastActiveEditorView = function updateLastActiveEditorView(editorView) {
  lastActiveEditorView = editorView;
};
export var isLastActiveEditorView = function isLastActiveEditorView(editorView) {
  return editorView === lastActiveEditorView;
};
export var useTrackLastActiveEditorView = function useTrackLastActiveEditorView(editorView) {
  useEffect(function () {
    var handleFocus = function handleFocus() {
      return updateLastActiveEditorView(editorView);
    };
    var editorDom = editorView.dom;
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    editorDom.addEventListener('focus', handleFocus);
    return function () {
      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      editorDom.removeEventListener('focus', handleFocus);
    };
  }, [editorView]);
};